import { DivisionType } from './common'
import { Kartomat } from './kartomat'
import { Region } from './region'

export enum UserRole {
  Administrator = 'administrator',
  AdministratorCIB = 'administratorcib',
  Manager = 'manager',
  Controller = 'controller',
  SuperController = 'super_controller',
  Supervisor = 'supervisor',
  Consultant = 'consultant',
  Author = 'author',
  Executor = 'executor',
  Deliveryman = 'deliveryman',
  ControllerUKC = 'logistic_control',
  Specialist = 'specialist',
  SPECIALIST_B2B = 'specialistb2b',
  ONLY_VIEW = 'only_view',
}

export interface UnitBranch {
  id: number
  name: string
}

export type UserPermission =
  | 'can_credit'
  | 'can_installment'
  | 'can_cards'
  | 'can_mkassa'
  | 'can_mpost'
  | 'can_mbusiness'
  | 'can_open_mbusiness'
  | 'can_uni_murabaha'
  | 'can_murabaha'
  | 'can_hasan'
  | 'can_m_junior'
  | 'can_nonresident_card'
  | 'can_mqr'
  | 'can_rko'
  | 'can_chenge_tarif'
  | 'can_removal_pos'
  | 'can_chenge_pos'
  | 'delivery_can_cart'
  | 'delivery_can_mpost'
  | 'can_technical_support'
  | 'can_subscribe_services'
  | 'can_kartomat'
  | 'can_m_bonus'
  | 'can_m_plus_line'
  | 'can_credit_2'
  | 'can_kartomat_identification'

export interface User {
  supervisor?: string
  region?: Region
  phone: string
  tgm_username: string
  email: string
  first_name: string
  last_login?: string
  last_name: string
  middle_name: string
  block_reason: string
  id: number
  role: UserRole
  is_active: boolean
  avatar: string
  tgm_user_id: string
  jira_id?: number | string
  units_lending?: {
    id: number
    code: string
    name: string
  }
  mbonus_department?: string
  inn: string
  type_division?: DivisionType
  main_branch?: UnitBranch
  branches?: UnitBranch
  project?: number
  executor?: string
  kartomat?: Kartomat[]
  user_permissions: UserPermission[]
}

export interface UserDTO
  extends Omit<
    User,
    | 'units_lending'
    | 'main_branch'
    | 'branches'
    | 'region'
    | 'kartomat'
    | 'mbonus_department'
  > {
  units_lending?: string | number
  main_branch?: string | number
  branches?: string | number
  mbonus_department?: string
  password?: string
  region?: string | number
  kartomat?: string[]
}
